import { previewInsightsApiSlice } from "./PreviewInsights.redux";

export const {
    resetInsightsPreviewObject
} = previewInsightsApiSlice.actions